import React, { useState } from 'react';
import GameScreen from './screens/GameScreen';
import LevelSelectScreen from './screens/LevelSelectScreen';
import StatisticsScreen from './screens/StatisticsScreen';
import './App.css';

function App() {
  // Possíveis valores: 'levelSelect' | 'game' | 'statistics'
  const [currentScreen, setCurrentScreen] = useState('levelSelect');
  const [selectedLevel, setSelectedLevel] = useState('nivel_1');

  const handleSelectLevel = (nivelId) => {
    setSelectedLevel(nivelId);
    setCurrentScreen('game');
  };

  const handleBackToLevels = () => {
    setCurrentScreen('levelSelect');
  };

  const handleNavigateToStats = () => {
    setCurrentScreen('statistics');
  };

  return (
    <div className="App">
      {currentScreen === 'levelSelect' && (
        <LevelSelectScreen 
          onSelectLevel={handleSelectLevel}
          onNavigateToStats={handleNavigateToStats}
        />
      )}

      {currentScreen === 'game' && (
        <GameScreen
          nivelId={selectedLevel}
          onNavigate={(screen) => {
            if (screen === 'levels') handleBackToLevels();
          }}
        />
      )}

      {currentScreen === 'statistics' && (
        <StatisticsScreen 
          onBackToMenu={() => setCurrentScreen('levelSelect')}
        />
      )}
    </div>
  );
}

export default App;
